import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
import intlFormat from 'date-fns/intlFormat';

import FormatDays from 'src/components/FormatDays';
import FormatTime from 'src/components/FormatTime';

import theme from 'src/styles/components/FormatSchedule.module.scss';

const FormatSchedule = ({
    schedule,
    className
}) => {
    const intl = useIntl();

    return (
        <div className={classnames(className, theme.availability)}>
            <div>
                <FormatDays schedule={schedule} />
                {!schedule.wholeDay && Boolean(schedule.fromTime) && (
                    <span>
                        {' '}
                        {intl.formatMessage({ id: 'App.from' })}
                        {' '}
                        <b><FormatTime time={schedule.fromTime} /></b>
                    </span>
                )}
                {!schedule.wholeDay && Boolean(schedule.toTime) && (
                    <span>
                        {' '}
                        {intl.formatMessage({ id: 'App.to' })}
                        {' '}
                        <b><FormatTime time={schedule.toTime} /></b>
                    </span>
                )}
            </div>
            <div>
                {!schedule.everyYear && Boolean(schedule.fromDate) && (
                    <span>
                        {intl.formatMessage({ id: 'App.from' })}
                        {' '}
                        <b>{intlFormat(schedule.fromDate, {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                        }, { locale: intl.locale })}</b>
                    </span>
                )}
                {!schedule.everyYear && Boolean(schedule.toDate) && (
                    <span>
                        {' '}
                        {intl.formatMessage({ id: 'App.to' })}
                        {' '}
                        <b>{intlFormat(schedule.toDate, {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                        }, { locale: intl.locale })}</b>
                    </span>
                )}
                {schedule.everyYear && !schedule.wholeYear && (
                    <span>
                        {intl.formatMessage({ id: 'App.from' })}
                        {' '}
                        <b>{intlFormat(schedule.fromDate, {
                            month: 'long',
                            day: 'numeric'
                        }, { locale: intl.locale })}</b>
                        {' '}
                        {intl.formatMessage({ id: 'App.to' })}
                        {' '}
                        <b>{intlFormat(schedule.toDate, {
                            month: 'long',
                            day: 'numeric'
                        }, { locale: intl.locale })}</b>
                    </span>
                )}
            </div>
        </div>
    );
};

FormatSchedule.propTypes = {
    schedule: PropTypes.shape({
        days: PropTypes.arrayOf(PropTypes.string),
        everyYear: PropTypes.bool,
        fromDate: PropTypes.instanceOf(Date),
        fromTime: PropTypes.string,
        toDate: PropTypes.instanceOf(Date),
        toTime: PropTypes.string,
        wholeDay: PropTypes.bool,
        wholeYear: PropTypes.number
    }).isRequired,
    className: PropTypes.string
};

export default FormatSchedule;
